import { render, staticRenderFns } from "./classificator-input.vue?vue&type=template&id=f02b4a94&scoped=true"
import script from "./classificator-input.vue?vue&type=script&lang=js"
export * from "./classificator-input.vue?vue&type=script&lang=js"
import style0 from "./classificator-input.vue?vue&type=style&index=0&id=f02b4a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02b4a94",
  null
  
)

export default component.exports